module.exports = __webpack_public_path__ + "static/media/instantnanobiosensors.608c1ebe.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/instantnanobiosensors.webp
// module id = 280
// module chunks = 0